export type AuditDataAssetsFilesBody = {
  uploadedAssetId: string;
  imageId: string | null;
  url: string;
  resizeUrl: string;
  meta: string;
  directory: string | null;
};
